import React, { useState, useEffect  } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Modal, Box, useMediaQuery,
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { esignToolApi } from "../../services/esignApi";
import Loader from "../../components/Loader";

const ForgotPasswrod = ({forgotPasswordOpen, setForgotPasswordOpen, setNewPasswordOpen, setLoginOpen}) => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [helperText, setHelperText] = useState({email: "", password: "" });
  const [errors, setErrors] = useState({email: "", password: "" });
  const [loader, setLoader] = useState(false);
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme => theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));

  const validateEmail = (value) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  };

  const validateInputs = () => {
    let newErrors = {email: "", password: "" };
    let newHelperText = {email: "", password: "" };
    let isValid = true;
    
    if (!email) {
      newErrors.email = "Email is required";
      newHelperText.email = "Email is required";
      isValid = false;
    }

    if (!validateEmail(email) && email) {
        newErrors.email = "Invalid email address";
        newHelperText.email = "Invalid email address";
        isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
        setEmail(value);
        if (!validateEmail(value) && value) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: "Invalid email address",
            }));
            setHelperText((prevHelperText) => ({
                ...prevHelperText,
                email: "Invalid email address",
            }));

        } else {
            setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
            setHelperText((prevHelperText) => ({ ...prevHelperText, email: "" }));
        }
    }
  };


  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoader(true)
      localStorage.setItem('email', email);
      try {
        const response = await esignToolApi.sendOtpForgotPassword(email);
        console.log(response)
        if (response && response.status===true) {
          // navigate("/new-password");
          setLoader(false);
          setForgotPasswordOpen(false);
          setNewPasswordOpen(true);
        } else {
          setLoader(false)
          console.error("Failed to verify otp:", response);
        }
      } catch (error) {
        setLoader(false)
        console.error("Error verifyotp:", error);
      }
    }
  };
  

  return (
    <>
      <Modal open={forgotPasswordOpen} onClose={() => setForgotPasswordOpen(false)} sx={{ backdropFilter: "blur(5px)", background: "#1D1D1D99"}} slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "transparent",
          },
        },
      }}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: isSmallScreen ? "90%" : "500px", maxHeight: "600px", backgroundColor: "#fff", boxShadow: 24, overflow: "auto", borderRadius: "20px", }}>
          <Paper elevation={3} sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontSize: '24px' }}>
                Let me save you!
            </Typography>

            <TextField
              placeholder="Email address"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => {
                handleChange(e);
              }}
              error={!!errors.email}
              sx={{
                mt: 2,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.email ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <img src={`${process.env.PUBLIC_URL}/images/mail.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                    </InputAdornment>
                ),
                sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: email ? "600" : "400" },
              }}
            />

            {!! errors.email && (
                <Typography
                sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto"
                }}
                >
                {helperText.email}
                </Typography>
            )}

            <Button
              variant="contained"
              sx={{
                mt: 3,
                width: '100%',
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={handleSubmit}
            >
              Send OTP
            </Button>

            <Typography
              sx={{
                  mt: 2,
                  fontSize: "16px",
                  color: "#00000",
                  cursor: "pointer",
                  fontWeight: 600,
                  transition: "color 0.2s ease-in-out",
                  "&:hover": { color: "#185CB7",
                    textDecoration: "underline", }
              }}
              onClick={() => {setForgotPasswordOpen(false); setLoginOpen(true);}}
              >
              Forget it, I just remembered
              </Typography>
          </Paper>
        </Box>
      </Modal>
      {loader && <Loader />}
    </>
  );
};

export default ForgotPasswrod;
